import HorizontalBarChart from './HorizontalBarChart';
import './HorizontalBarChart.scss';

export default HorizontalBarChart;